module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0128.jpg?v=f944eae9";